import { Divider } from "@material-ui/core";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SettingsIcon from '@mui/icons-material/Settings';
import Close from '@mui/icons-material/Close';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Tooltip from '../tooltip/index.js';
import { PropertiesContainer } from "./style.js";
import Button from '@material-ui/core/Button';
import './index.css'
import { BannerContext } from '../../contexts/BannerDimensionsContext';
import React, { useContext, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import TooltipCompliance from '@mui/material/Tooltip';
import { AuthValidatorContext } from '../../contexts/auth';

const Properties = ({
    fullScreenRight,
    setPropertiesActive,
    propertiesActive,
    banner,
    customGrid,
    setCustomGrid,
    setLayoutStage,
    layoutStage,
    showMenu,
    showStep,
    changeShowStep,
    handleCollapse,
    collapsedDivs,
    setReload,
    reload,
    activeElement,
    setActiveElement,
    setClassButton,
    setOpenTooltip,
    openTooltip,
    editGrid,
    handleSelectChange,
    setTempLine,
    setEditGrid,
    setGrid,
    grid,
    backgroundStage,
    setBackgroundStage,
    Root,
    showStages,
    changeValueTooltip,
    previewZoomToSteps,
    setPreviewZoomToSteps
}) => {
  const { replicaActive ,listaReplicas, setListaReplicas, modalSeed, setModalSeed, master, isIABFormat, setIsIABFormat, isIABWeight, setIsIABWeight, isGloboFormat, setIsGloboFormat, isGloboWeight, setIsGloboWeight,
    globoWeightHosted, setGloboWeightHosted, globoWeightTag, setGloboWeightTag, setStagesActive, stagesActive, setComplianceActive, complianceActive } = useContext(BannerContext);
  const [ checked, setChecked ] = useState(null);
  const active = replicaActive.split('x');
  const index = listaReplicas.findIndex(x => x.width.toString() === active[0] && x.height.toString() === active[1]);
  const { roles } = useContext(AuthValidatorContext);

  function seed () {
    var replica = JSON.parse(JSON.stringify(listaReplicas[index]));
    setSeed(checked, replica);
    setModalSeed(false);
  }

  function setSeed(source, dest) {
    const scale = {
      width: source.width / dest.width,
      height: source.height / dest.height,
      scale:  dest.height >= dest.width ? source.width / dest.width : source.height / dest.height
    };
    source.elements.forEach((element, index) => {
      dest.elements[index].properties.top = (element.properties.top / scale.height).toFixed(0);
      dest.elements[index].properties.left = (element.properties.left / scale.width).toFixed(0);
      dest.elements[index].properties.scale = (element.properties.scale / scale.scale).toFixed(0);
    });
    var newListaReplicas = JSON.parse(JSON.stringify(listaReplicas));
    newListaReplicas[index] = dest;
    setListaReplicas(newListaReplicas);
  }

  const [ iabTabActive, setIabTabActive ] = useState('iab');

    const handleIabTabActive = (type) => {
      setIabTabActive(`${type}`)
    };
  
    const formatos = [
      { minLargura: 160, minAltura: 640, maxLargura: 240, maxAltura: 960, pesoMaximo: "300kb" },
      { minLargura: 200, minAltura: 100, maxLargura: 300, maxAltura: 150, pesoMaximo: "100kb" },
      { minLargura: 300, minAltura: 50, maxLargura: 450, maxAltura: 75, pesoMaximo: "100kb" },
      { minLargura: 300, minAltura: 150, maxLargura: 450, maxAltura: 225, pesoMaximo: "200kb" },
      { minLargura: 300, minAltura: 300, maxLargura: 450, maxAltura: 450, pesoMaximo: "300kb" },
      { minLargura: 300, minAltura: 450, maxLargura: 450, maxAltura: 675, pesoMaximo: "400kb" },
      { minLargura: 300, minAltura: 540, maxLargura: 450, maxAltura: 800, pesoMaximo: "400kb" },
      { minLargura: 300, minAltura: 600, maxLargura: 450, maxAltura: 900, pesoMaximo: "400kb" },
      { minLargura: 300, minAltura: 900, maxLargura: 450, maxAltura: 1350, pesoMaximo: "500kb" },
      { minLargura: 450, minAltura: 300, maxLargura: 675, maxAltura: 450, pesoMaximo: "400kb" },
      { minLargura: 540, minAltura: 300, maxLargura: 800, maxAltura: 450, pesoMaximo: "400kb" },
      { minLargura: 600, minAltura: 75, maxLargura: 1200, maxAltura: 150, pesoMaximo: "300kb" },
      { minLargura: 600, minAltura: 800, maxLargura: 900, maxAltura: 1200, pesoMaximo: "600kb" },
      { minLargura: 600, minAltura: 1067, maxLargura: 900, maxAltura: 1600, pesoMaximo: "600kb" },
      { minLargura: 800, minAltura: 600, maxLargura: 1200, maxAltura: 900, pesoMaximo: "600kb" },
      { minLargura: 800, minAltura: 1280, maxLargura: 1200, maxAltura: 1920, pesoMaximo: "600kb" },
      { minLargura: 900, minAltura: 90, maxLargura: 1800, maxAltura: 180, pesoMaximo: "400kb" },
      { minLargura: 900, minAltura: 225, maxLargura: 1800, maxAltura: 450, pesoMaximo: "500kb" },
      { minLargura: 900, minAltura: 450, maxLargura: 1800, maxAltura: 900, pesoMaximo: "500kb" },
      { minLargura: 1067, minAltura: 600, maxLargura: 1600, maxAltura: 900, pesoMaximo: "600kb" },
      { minLargura: 1280, minAltura: 800, maxLargura: 1920, maxAltura: 1200, pesoMaximo: "600kb" },
      { minLargura: 120, minAltura: 20, maxLargura: 120, maxAltura: 20, pesoMaximo: "50kb" },
      { minLargura: 168, minAltura: 28, maxLargura: 168, maxAltura: 28, pesoMaximo: "100kb" },
      { minLargura: 216, minAltura: 36, maxLargura: 216, maxAltura: 36, pesoMaximo: "100kb" },
      { minLargura: 300, minAltura: 250, maxLargura: 300, maxAltura: 250, pesoMaximo: "150kb" },
      { minLargura: 160, minAltura: 600, maxLargura: 160, maxAltura: 600, pesoMaximo: "150kb" },
      { minLargura: 120, minAltura: 60, maxLargura: 120, maxAltura: 60, pesoMaximo: "50kb" }
    ];
  
    function isFormatoValidoEWeight(width, height, size) {
      for (let formato of formatos) {
        if (
          width >= formato.minLargura &&
          width <= formato.maxLargura &&
          height >= formato.minAltura &&
          height <= formato.maxAltura
        ) {
          const pesoMaximo = formato.pesoMaximo;
          const pesoValido = pesoMaximo === null || size <= extrairPesoMaximo(pesoMaximo);
          return { formato, pesoValido };
        }
      }
      return { formato: null, pesoValido: false };
    }
    
    function extrairPesoMaximo(pesoMaximo) {
      const valorNumerico = parseFloat(pesoMaximo);
      if (!isNaN(valorNumerico)) {
        if (pesoMaximo.includes('kb')) {
          return valorNumerico;
        } else if (pesoMaximo.includes('mb')) {
          return valorNumerico * 1000;
        }
      }
      return Infinity;
    }
    
    const { formato, pesoValido } = isFormatoValidoEWeight((replicaActive.slice(0, replicaActive.indexOf('x'))), (replicaActive.slice(replicaActive.indexOf('x')+1)), banner.size);
    
    setIsIABFormat(formato !== null);
    setIsIABWeight(pesoValido);
    
    const pesoMaximo = formato ? formato.pesoMaximo : 'Desconhecido';
  
    const tooltips = {
      "300x50": "Formato em transição: Será substituído por banner horizontal 6x1.",
      "320x50": "Formato em transição: Será substituído por banner horizontal 6x1.",
      "970x250": "Formato em transição: Será substituído por banner horizontal 4x1.",
      "728x90": "Formato em transição: Será substituído por banner horizontal 8x1.",
      "300x1050": "Formato em transição: Será substituído por retrato vertical 1x3.",
      "300x600": "Formato em transição: Será substituído por retrato vertical 1x2.",
      "300x250": "Formato em transição: Será substituído por retrato vertical 1x1.",
      "160x600": "Formato em transição: Será substituído por retrato vertical 1x4.",
      "120x60": "Formato em transição: Será substituído por anúncio tamanho pequeno 2x1."
    };
  
    const formatoTooltip = tooltips[`${(replicaActive.slice(0, replicaActive.indexOf('x')))}x${(replicaActive.slice(replicaActive.indexOf('x')+1))}`];

    const formatosGlobo = [
      { largura: 300, altura: 250, pesoHosted: "150kb", pesoTag: "350kb" },
      { largura: 300, altura: 600, pesoHosted: "250kb", pesoTag: "550kb" },
      { largura: 320, altura: 50, pesoHosted: "100kb", pesoTag: "150kb" },
      { largura: 320, altura: 100, pesoHosted: "100kb", pesoTag: "150kb" },
      { largura: 970, altura: 90, pesoHosted: "150kb", pesoTag: "350kb" },
      { largura: 970, altura: 150, pesoHosted: "200kb", pesoTag: "450kb" },
      { largura: 970, altura: 250, pesoHosted: "250kb", pesoTag: "550kb" },
      { largura: 1248, altura: 250, pesoHosted: "250kb", pesoTag: "550kb" }
    ];
  
    const formatoGlobo = formatosGlobo.find(formato => {
      return formato.largura === parseInt(replicaActive.slice(0, replicaActive.indexOf('x'))) && 
             formato.altura === parseInt(replicaActive.slice(replicaActive.indexOf('x')+1));
    });

    if (formatoGlobo) {
      const { pesoHosted, pesoTag } = formatoGlobo;
      const isGloboWeight = parseInt(banner.size) <= parseInt(pesoHosted);
      
      setIsGloboFormat(true);
      setIsGloboWeight(isGloboWeight);
      setGloboWeightHosted(pesoHosted);
      setGloboWeightTag(pesoTag);
    } else {
      setIsGloboFormat(false);
    }

    return (
      <PropertiesContainer className="container-list-layers" fullScreenRight={fullScreenRight}>
        {
          modalSeed ?
          <div className="modal-seed-replica">
            <div className="modal-seed-item">
              <CloseIcon onClick={() => setModalSeed(false)} className="modal-close-icon"/>
              <div key={Math.random()}>
                <Checkbox checked={checked === master} onClick={() => setChecked(master)} />
                {master.width}x{master.height} (master)
              </div>
              {listaReplicas.map((item, i) =>
                i === index ?
                null
                 :
                <div key={Math.random()}>
                  <Checkbox  checked={checked === item} onClick={() => setChecked(item)} />
                  {item.width}x{item.height}
                </div>
              )}
              <Button variant="contained" color="primary" onClick={() => seed()} disabled={!checked} >Aplicar</Button>
            </div>
          </div>
          :
          <></>
        }
        <div className="containerProperties">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "95%",
              alignItems: "flex-start",
            }}
          >
            <div
              className="propertiesNameAndArrow"
              onClick={() => setPropertiesActive(!propertiesActive)}
            >
              <span
                className="textPropertiesStages"
                onClick={() => setPropertiesActive(!propertiesActive)}
              >
                Propriedades
              </span>
              {propertiesActive ? (
                <img
                  alt="arrow"
                  src="assets/arrownew.png"
                  className="stepNumberArrowUp"
                  onClick={() => setPropertiesActive(!propertiesActive)}
                  style={{
                    padding: "5px",
                    cursor: "pointer",
                    width: "11px",
                    height: "7px",
                    margin: "12px 0 0 0",
                  }}
                />
              ) : (
                <img
                  alt="arrow"
                  src="assets/arrownew.png"
                  className="stepNumberArrowUp"
                  onClick={() => setPropertiesActive(!propertiesActive)}
                  style={{
                    transform: "rotate(180deg)",
                    padding: "5px",
                    cursor: "pointer",
                    width: "11px",
                    height: "7px",
                    margin: "12px 0 0 0",
                    userSelect: "none",
                  }}
                />
              )}
            </div>
            <Divider className="propertiesDivider" />
            {propertiesActive ? (
              <div style={{ margin: "0 0 5px 6px" }}>
                <div style={{display: 'flex', flexDirection: 'column', width: '205px'}}>
                  <button className="btnChangeBase" onClick={() => setModalSeed(true)}>Alterar base</button>
                  
                  {
                    !banner.estatico ?
                    <span className="sizeText">
                      Tamanho:{" "}
                      <span className="sizeTextValue">{banner.size}kb</span>
                    </span>
                    : <></>
                  }
                </div>
                <div className="containerQuality">
                  <select
                    value={banner.optimize}
                    onChange={handleSelectChange}
                    style={{
                      border: "none",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      fontSize: "16px",
                      width: "70px",
                      height: "30px",
                      padding: "0 0 2px 5px",
                      margin: "-5px 10px 0 0",
                    }}
                  >
                    <option value="100">100%</option>
                    <option value="90">90%</option>
                    <option value="80">80%</option>
                    <option value="70">70%</option>
                    <option value="60">60%</option>
                    <option value="50">50%</option>
                    <option value="40">40%</option>
                    <option value="30">30%</option>
                    <option value="20">20%</option>
                    <option value="10">10%</option>
                  </select>
                  <span className="qualityText">Qualidade</span>
                </div>
  
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "5px 0 10px -4px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",
                    }}
                  >
                    <input
                      type="checkbox"
                      component={Root}
                      checked={editGrid}
                      onChange={() => {
                        const index = customGrid.findIndex(
                          (x) =>
                            x.width === banner.width && x.height === banner.height
                        );
                        if (index === -1) {
                          let copyCustomGrid = JSON.parse(
                            JSON.stringify(customGrid)
                          );
                          copyCustomGrid.push({
                            width: banner.width,
                            height: banner.height,
                            x: [],
                            y: [],
                          });
                          setCustomGrid(copyCustomGrid);
                        }
                        setTempLine(null);
                        setEditGrid(!editGrid);
                      }}
                      style={{ accentColor: "#68498C" }}
                    />
                    <span
                      style={{
                        fontWeight: "normal",
                        fontSize: "16px",
                        margin: "-1px 0 0 5px",
                      }}
                    >
                      Régua
                    </span>
                    <HighlightOffIcon
                      onClick={() => {
                        const index = customGrid.findIndex(
                          (x) =>
                            x.width === banner.width && x.height === banner.height
                        );
                        let copyCustomGrid = JSON.parse(
                          JSON.stringify(customGrid)
                        );
                        if (index === -1) {
                          copyCustomGrid.push({
                            width: banner.width,
                            height: banner.height,
                            x: [],
                            y: [],
                          });
                        } else {
                          copyCustomGrid[index].x = [];
                          copyCustomGrid[index].y = [];
                        }
                        setCustomGrid(copyCustomGrid);
                      }}
                    />
                  </div>
                  <div className="containerGrid">
                    <input
                      type="checkbox"
                      component={Root}
                      checked={grid}
                      onChange={() => setGrid(!grid)}
                      style={{ accentColor: "#68498C" }}
                    />
                    <span
                      style={{
                        fontWeight: "normal",
                        fontSize: "16px",
                        margin: "-1px 0 0 5px",
                      }}
                    >
                      Habilitar Grid
                    </span>
                  </div>
  
                  <div className="containerBackground">
                    <input
                      type="checkbox"
                      component={Root}
                      checked={backgroundStage}
                      onChange={() => setBackgroundStage(!backgroundStage)}
                      style={{ accentColor: "#68498C" }}
                    />
                    <span
                      style={{
                        fontWeight: "normal",
                        fontSize: "16px",
                        margin: "-1px 0 0 5px",
                      }}
                    >
                      Background
                    </span>
                  </div>
  
                  <div className="containerHorizontal">
                    <input
                      type="checkbox"
                      component={Root}
                      checked={layoutStage}
                      onChange={() => setLayoutStage(!layoutStage)}
                      style={{ accentColor: "#68498C" }}
                    />
                    <span
                      style={{
                        fontWeight: "normal",
                        fontSize: "16px",
                        margin: "-1px 0 0 5px",
                      }}
                    >
                      Layout Horizontal
                    </span>
                  </div>

                  <div className="containerPreviewZoomToSteps">
                    <input
                      type="checkbox"
                      component={Root}
                      checked={previewZoomToSteps}
                      style={{ accentColor: "#68498C" }}
                      onChange={() => setPreviewZoomToSteps(!previewZoomToSteps)}
                    />
                    <span
                      style={{
                        fontWeight: "normal",
                        fontSize: "16px",
                        margin: "-1px 0 0 5px",
                      }}
                    >
                      Aplicar zoom aos steps
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
  
          <div className="containerCompliance">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "95%",
              alignItems: "flex-start",
            }}
          >{
            roles.compliance ?
           <div
             className="propertiesNameAndArrow"
             onClick={() => setComplianceActive(!complianceActive)}
           >
             <span
               className="textPropertiesStages"
               onClick={() => setComplianceActive(!complianceActive)}
             >
               Compliance
             </span>
             {complianceActive ? (
               <img
                 alt="arrow"
                 src="assets/arrownew.png"
                 className="stepNumberArrowUp"
                 onClick={() => setComplianceActive(!complianceActive)}
                 style={{
                   padding: "5px",
                   cursor: "pointer",
                   width: "11px",
                   height: "7px",
                   margin: "12px 0 0 0",
                 }}
               />
             ) : (
               <img
                 alt="arrow"
                 src="assets/arrownew.png"
                 className="stepNumberArrowUp"
                 onClick={() => setComplianceActive(!complianceActive)}
                 style={{
                   transform: "rotate(180deg)",
                   padding: "5px",
                   cursor: "pointer",
                   width: "11px",
                   height: "7px",
                   margin: "12px 0 0 0",
                   userSelect: "none",
                 }}
               />
             )}
           </div>
           : <></>
         }
            <Divider className="propertiesDivider" />
            {complianceActive ? (
              <div style={{ margin: "0 0 5px 0px" }}>
                <div style={{margin: '0px 12px 0px 0px'}}>
                  <div>
                    {isIABFormat ?
                    <div className='iabContainer'>
                      <div className="iabContainerLogosBg">
                        <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : 'none', borderLeft: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : 'none', borderRight: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : 'none'}} onClick={() => handleIabTabActive('iab')} >
                          {isIABWeight ? 
                            <img className='containerIAB-title-yes' src="assets/logo_iab.png"></img>
                          :
                            <img className='containerIAB-title-no' src="assets/logo_iab.png"></img>
                          }
                        </div>
                        <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 0.6)", borderLeft: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 0.6)", borderRight: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 1)"}} onClick={() => handleIabTabActive('globo')} >
                          {isGloboWeight ?
                            <img className='logoglobo-yes' src="assets/logo_globo.png"></img>
                          :
                            <img className='logoglobo-no' src="assets/logo_globo.png"></img>
                          }
                        </div>
                        <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', position: 'absolute', left: '0px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? '#FFFFFF' : "1px solid rgba(104, 73, 140, 0.6)" }}></div>
                        <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', position: 'absolute', left: '130px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : '#FFFFFF'}}></div>
                      </div>
                      {iabTabActive === 'iab' ?
                      <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', padding: '10px 0 5px 10px', borderBottom: "1px solid rgba(104, 73, 140, 0.6)", borderLeft: "1px solid rgba(104, 73, 140, 0.6)", borderRight: "1px solid rgba(104, 73, 140, 0.6)"}}>
                        <div>
                          <b>Formato:</b> {(replicaActive.slice(0, replicaActive.indexOf('x')))}x{(replicaActive.slice(replicaActive.indexOf('x')+1))}
                            {formatoTooltip ?
                              <TooltipCompliance title={formatoTooltip}><span className='containerIAB-question'> (?)</span></TooltipCompliance>
                            :
                              <TooltipCompliance title={'Este formato é atualmente aceito pela IAB.'}><span className='containerIAB-yes'> (✓)</span></TooltipCompliance>
                            }
                        </div>
                        <div className='containerIAB-weight'>
                          <b>Peso:</b> {banner.size}kb
                            {isIABWeight ? 
                              <TooltipCompliance title={`O peso máximo recomendado para este formato é ${pesoMaximo}.`}><span className='containerIAB-yes'> (✓)</span></TooltipCompliance>
                            :
                              <TooltipCompliance title={`O peso máximo recomendado para este formato é ${pesoMaximo}.`}><span className='containerIAB-no'> (✗)</span></TooltipCompliance>
                            }
                        </div>
                        <div className='containerIAB-duration'>
                          <b>Tempo de animação:</b> {(banner.duration * banner.loop).toFixed(1)}s
                            {banner.duration * banner.loop <= 15 ?
                              <TooltipCompliance title={'O tempo de animação não deve exceder 15 segundos ou conter looping além dos 15 segundos.'}><span className='containerIAB-yes'> (✓)</span></TooltipCompliance>
                            :
                              <TooltipCompliance title={'O tempo de animação não deve exceder 15 segundos ou conter looping além dos 15 segundos.'}><span className='containerIAB-no'> (✗)</span></TooltipCompliance>
                            }
                        </div>
                      </div>       
                      :
                      <div>
                        {isGloboFormat ? 
                          <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '10px 0 5px 10px', borderBottom: "1px solid rgba(104, 73, 140, 0.6)", borderLeft: "1px solid rgba(104, 73, 140, 0.6)", borderRight: "1px solid rgba(104, 73, 140, 0.6)"}}>
                            <div>
                              <b>Formato:</b> {(replicaActive.slice(0, replicaActive.indexOf('x')))}x{(replicaActive.slice(replicaActive.indexOf('x')+1))}
                              <TooltipCompliance title={'Este formato é atualmente aceito pela Globo.'}><span className='containerIAB-yes'> (✓)</span></TooltipCompliance>
                            </div>
                            <div className='containerIAB-weight'>
                              <b>Peso:</b> {banner.size}kb
                                {isGloboWeight ? 
                                  <TooltipCompliance title={`Peso máximo hosted ${globoWeightHosted}, peso máximo tag ${globoWeightTag}.`}><span className='containerIAB-yes'> (✓)</span></TooltipCompliance>
                                :
                                  <TooltipCompliance title={`Peso máximo hosted ${globoWeightHosted}, peso máximo tag ${globoWeightTag}.`}><span className='containerIAB-no'> (✗)</span></TooltipCompliance>
                                }
                            </div>
                            <div className='containerIAB-duration'>
                              <b>Tempo de animação:</b> {(banner.duration * banner.loop).toFixed(1)}s
                                {banner.duration*banner.loop <= 15 && banner.loop <= 3 ?
                                  <TooltipCompliance title={'O tempo de animação máximo recomendado é de 15 segundos com até 3 loopings.'}><span className='containerIAB-yes'> (✓)</span></TooltipCompliance>
                                :
                                  <TooltipCompliance title={'O tempo de animação máximo recomendado é de 15 segundos com até 3 loopings.'}><span className='containerIAB-no'> (✗)</span></TooltipCompliance>
                                }
                            </div>
                          </div>
                        :
  
                          <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '10px 0 0 10px', borderBottom: "1px solid rgba(104, 73, 140, 0.6)", borderLeft: "1px solid rgba(104, 73, 140, 0.6)", borderRight: "1px solid rgba(104, 73, 140, 0.6)"}}>
                            <p className='containerIAB-text'>
                              O formato {(replicaActive.slice(0, replicaActive.indexOf('x')))}x{(replicaActive.slice(replicaActive.indexOf('x')+1))} não é atualmente aceito pela Globo.
                            </p>
                            <p className='containerIAB-text2'>Clique <a href='https://negocios.globo.com/orientacoes-gerais/' target='_blank'>aqui</a> para saber mais.</p>
                          </div>
                        }
                      </div>
                      }
                    </div>
                    :
                    <div className='iabContainer'>
                      <div className="iabContainerLogosBg">
                        <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : 'none', borderLeft: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : 'none', borderRight: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : 'none'}} onClick={() => handleIabTabActive('iab')} >
                          {isIABWeight ? 
                            <img className='containerIAB-title-yes' src="assets/logo_iab.png"></img>
                          :
                            <img className='containerIAB-title-no' src="assets/logo_iab.png"></img>
                          }
                        </div>
                        <div className="iabContainerLogosTab" style={{zIndex: 1, borderTop: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 0.6)", borderLeft: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 0.6)", borderRight: iabTabActive === 'iab' ? 'none' : "1px solid rgba(104, 73, 140, 1)"}} onClick={() => handleIabTabActive('globo')} >
                          {isGloboWeight ?
                            <img className='logoglobo-yes' src="assets/logo_globo.png"></img>
                          :
                            <img className='logoglobo-no' src="assets/logo_globo.png"></img>
                          }
                        </div>
                        <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', position: 'absolute', left: '0px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? '#FFFFFF' : "1px solid rgba(104, 73, 140, 0.6)"}}></div>
                        <div className="iabContainerLogosTab" style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', position: 'absolute', left: '130px', transition: 'left 500ms', borderBottom: iabTabActive === 'iab' ? "1px solid rgba(104, 73, 140, 0.6)" : '#FFFFFF'}}></div>
                      </div>
                      {iabTabActive === 'iab' ?
                        <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#FFFFFF' : '#F7F7F7', padding: '10px 0 0 10px', borderBottom: "1px solid rgba(104, 73, 140, 0.6)", borderLeft: "1px solid rgba(104, 73, 140, 0.6)", borderRight: "1px solid rgba(104, 73, 140, 0.6)"}}>
                          <p className='containerIAB-text'>
                            O formato {(replicaActive.slice(0, replicaActive.indexOf('x')))}x{(replicaActive.slice(replicaActive.indexOf('x')+1))} não é atualmente aceito pela IAB.
                          </p>
                          <p className='containerIAB-text2'>Clique <a href='https://iabbrasil.com.br/wp-content/uploads/2019/11/Ebook-IAB-Formatos-Anu%CC%81ncio-A5-DIAGRAMAC%CC%A7A%CC%83O-v4.pdf' target='_blank'>aqui</a> para saber mais.</p>
                        </div>
                      :
                        <div>
                          {isGloboFormat ? 
                            <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '6px 0 0 10px'}}>
                            </div>
                          :
                            <div className='containerInfos' style={{background: iabTabActive === 'iab' ? '#F7F7F7' : '#FFFFFF', padding: '10px 0 0 10px', borderBottom: "1px solid rgba(104, 73, 140, 0.6)", borderLeft: "1px solid rgba(104, 73, 140, 0.6)", borderRight: "1px solid rgba(104, 73, 140, 0.6)"}}>
                              <p className='containerIAB-text'>
                                O formato {(replicaActive.slice(0, replicaActive.indexOf('x')))}x{(replicaActive.slice(replicaActive.indexOf('x')+1))} não é atualmente aceito pela Globo.
                              </p>
                              <p className='containerIAB-text2'>Clique <a href='https://negocios.globo.com/orientacoes-gerais/' target='_blank'>aqui</a> para saber mais.</p>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  } 
                </div>
              </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="containerStages">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "95%",
              alignItems: "flex-start",
            }}
          >
            <div
              className="propertiesNameAndArrow"
              onClick={() => setStagesActive(!stagesActive)}
            >
              <span
                className="textPropertiesStages"
                onClick={() => setStagesActive(!stagesActive)}
              >
                Stages
              </span>
              {stagesActive ? (
                <img
                  alt="arrow"
                  src="assets/arrownew.png"
                  className="stepNumberArrowUp"
                  onClick={() => setStagesActive(!stagesActive)}
                  style={{
                    padding: "5px",
                    cursor: "pointer",
                    width: "11px",
                    height: "7px",
                    margin: "12px 0 0 0",
                  }}
                />
              ) : (
                <img
                  alt="arrow"
                  src="assets/arrownew.png"
                  className="stepNumberArrowUp"
                  onClick={() => setStagesActive(!stagesActive)}
                  style={{
                    transform: "rotate(180deg)",
                    padding: "5px",
                    cursor: "pointer",
                    width: "11px",
                    height: "7px",
                    margin: "12px 0 0 0",
                    userSelect: "none",
                  }}
                />
              )}
            </div>
            <Divider className="propertiesDivider" />
            {stagesActive ? (
              <div style={{ margin: "0 0 5px 0px" }}>
                <div
            style={{
              display: showStages ? "flex" : "none",
              flexDirection: "column",
              width: "100%",
              margin: "10px 0 10px 0",
            }}
          >
            {showStep.length
              ? showStep.map((steps, index) => (
                  <div
                    key={Math.random()}
                    style={{
                      opacity: showMenu ? "1" : "0",
                      transition: "width 200ms",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "10px",
                      margin: "0 0 10px 0px",
                      width: "290px",
                      border: "1px solid rgba(104, 73, 140, 0.6)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                        width: "290px",
                        margin: "5px 0 5px 0",
                      }}
                    >
                      <span className="stepsName">{steps.name}</span>
                      {showStep[index].show ? (
                        <VisibilityIcon
                          style={{ color: "#68498C" }}
                          onClick={() => changeShowStep(index)}
                        />
                      ) : (
                        <VisibilityOffIcon
                          style={{ color: "#A874E3" }}
                          onClick={() => changeShowStep(index)}
                        />
                      )}
                      {collapsedDivs[index] ? (
                        <img
                          alt="arrow"
                          src="assets/arrownew.png"
                          onClick={() => handleCollapse(index)}
                          style={{
                            transform: "rotate(180deg)",
                            padding: "5px",
                            width: "11px",
                            height: "7px",
                            margin: "0 0 0 150px",
                            cursor: "pointer",
                          }}
                        />
                      ) : (
                        <img
                          alt="arrow"
                          src="assets/arrownew.png"
                          onClick={() => handleCollapse(index)}
                          style={{
                            padding: "5px",
                            width: "11px",
                            height: "7px",
                            margin: "0 0 0 150px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </div>
                    {steps.show ? (
                      steps.elements.map((element) => (
                        <div
                          key={Math.random()}
                          style={{
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {!collapsedDivs[index] && (
                            <div
                              className={setClassButton(element)}
                              style={{
                                backgroundColor: "#EFEFEF",
                                borderRadius: "4px 4px 0 0",
                                margin: "0 0 5px 0",
                                width: "268px",
                              }}
                              onClick={() => {
                                const newActiveBanner = banner.elements.find(
                                  (e) => e.id === element
                                );
                                setActiveElement([newActiveBanner]);
                                setReload(!reload);
                              }}
                            >
                              {element}
                              {openTooltip ? (
                                <Close
                                  style={{ position: "absolute", right: "15px" }}
                                  onClick={() => {
                                    setOpenTooltip(false);
                                  }}
                                />
                              ) : (
                                <SettingsIcon
                                  style={{ position: "absolute", right: "15px" }}
                                  onClick={() => setOpenTooltip(true)}
                                />
                              )}
                            </div>
                          )}
                          {openTooltip ? (
                            <Tooltip
                              onClick={(type, value) =>
                                changeValueTooltip(type, value, element)
                              }
                              element={element}
                              activeElement={activeElement[0]}
                            />
                          ) : (
                            <></>
                          )}
                        </div>
                      ))
                    ) : (
                      <></>
                    )}
                  </div>
                ))
              : null}
          </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        </div>
      </PropertiesContainer>
    );
  };
  
  export default Properties;